/* tslint:disable */
/* eslint-disable */
export enum TemplateType {
  OptsConfig = 'opts-config',
  TenderConfig = 'tender-config',
  OrderChargeLimits = 'order-charge-limits',
  PosStatusNotifications = 'pos-status-notifications'
}
